import { UserFormData } from '../../types';
import { UserCreateInput } from 'types/schema-generated-types';
import maybeGetExternalId, { ExternalIdEntity } from 'utilities/external-id-util';

export const buildCreateUserPayload = (values: UserFormData): UserCreateInput => {
  return {
    firstName: values.firstName,
    lastName: values.lastName,
    username: values.email,
    organizationAssociations: values.organizationRoles.map(({ organization, role }) => ({
      organizationId: organization.id,
      organizationRoleId: [role.id]
    })),
    ...maybeGetExternalId({
      candidateSourceId: values.email,
      entities: values.organizationRoles.map(
        ({ organization }) => organization
      ) as ExternalIdEntity[]
    })
  };
};
